<hr class="upperline"/>

<div class="my-account-form-container terra-error-style">
  <form [formGroup]="pageForm" (ngSubmit)="save()" (keydown.enter)="$event.preventDefault()">
    <div class="form-grid">
      <!-- Company Name -->
      <div class="terra-form-field-wrapper">
        <label for="txtName" class="text-input-label">Company name</label>
        <mat-form-field appearance="outline">
          <input matInput id="txtName" formControlName="name" autocomplete="company-name" class="lo_sensitive"/>
          <mat-error *ngIf="pageForm.get('name').hasError('required')"> Required</mat-error>
        </mat-form-field>
      </div>

      <h2 class="section-title">Settings</h2>
      <div class="settings-container">
        <div class="terra-form-field-wrapper toggle-item">
          <span>Show GP Promote to LPs</span>
          <mat-slide-toggle hideIcon labelPosition="before" formControlName="showGpPromoteToLPs"></mat-slide-toggle>
        </div>
        <div class="terra-form-field-wrapper toggle-item">
          <span>Public Opportunities Page</span>
          <mat-slide-toggle hideIcon labelPosition="before" formControlName="publicOpportunitiesPage"></mat-slide-toggle>
        </div>
        <div class="opportunity-page-actions" *ngIf="FeatureFlags.isOn(model.featureFlags, FeatureFlags.InvestNow)">
          <span class="opportunity-page-action" [cdkCopyToClipboard]="publicOpportunitiesPageLink" (click)="snackbarMessage('Opportunities Page Link',$event)"><mat-icon class="smaller-icon">link</mat-icon> <span
            class="link-text">Copy opportunities link</span></span>
          <a [href]="publicOpportunitiesPageLink" class="opportunity-page-action" target="_blank">
            <mat-icon class="smaller-icon">open_in_new</mat-icon>
            <span class="link-text">View opportunities page</span></a>
        </div>
      </div>
      <!-- Whitelabeling -->
      <h2 class="section-title">Custom Email Branding</h2>
      <div class="full-width">
        <ng-container *ngIf="(isWhitelabelingEnabled$ | async); else whitelabelPreview">
          <div class="lo_sensitive"><b>From: </b>{{ agentDetails.emailsDomainWhitelabelSenderName }}</div>
          <div class="lo_sensitive"><b>Email address: </b>{{ agentDetails.emailsDomainWhitelabelSender }}</div>
        </ng-container>

        <ng-template #whitelabelPreview>
          <div class="example-block example-strip">
            <div class="lo_sensitive"><b>From: </b>Investor Relations</div>
            <div class="lo_sensitive"><b>Email address: </b>investors&#64;yourdomain.com</div>
            <p>
              Customize emails sent via Covercy GP Platform.<br/>
              Outgoing emails will be sent from your custom domain name.
            </p>
          </div>

          <p class="upsell-text">
            <mat-icon class="notranslate">lock</mat-icon>
            <span>Interested in our premium packages? Please
              <a target="_blank" href="https://www.covercy.com/contact-us" class="contact-us-link link"> contact us</a>
            </span>
          </p>
        </ng-template>
      </div>

      <h2 class="section-title">Address</h2>

      <terra-address-form [externalForm]="pageForm" partialFormName="locationDetails" class="form-grid-new full-width"
                          [locationDetailsResponse]="agentDetails?.organizationDetails?.locationDetails"
                          [formSettings]="addressFromSettings">
      </terra-address-form>

      <hr class="form-divider"/>

      <div>
        <terra-image-uploader-thumbnail formControlName="logoMetaFileLink" [isSubmitted]="isSubmitted">
          <label class="text-input-label">Upload company logo (optional)</label>
        </terra-image-uploader-thumbnail>
        <p class="file-uploader-hint new-column">File format must be JPG, JPEG, PNG (20 MB max file size)</p>
        <div class="copy-investor-link">
          <button class="page-cta copy-investor-link-button" [cdkCopyToClipboard]="brandedInvestorLink"
                  (click)="snackbarMessage('Branded investor portal link', $event)" color="accent" mat-button>
            <mat-icon class="notranslate">content_copy</mat-icon>
            Copy branded investor portal link
          </button>
        </div>
      </div>

      <!-- Error message -->
      <div *ngIf="isSubmitted" class="full-width">
        <p *ngIf="pageForm.invalid" class="error-message">
          Please review and correct the fields marked in red
        </p>
        <p *ngIf="isGeneralServerError" class="error-message">{{ generalServerErrorMessage }}</p>
        <p *ngIf="isFileNotSupported" class="error-message">{{ fileNotSupportedError }}</p>
      </div>

      <div class="form-actions full-width">
        <button type="submit" class="page-cta half-width tall-button" color="accent" mat-flat-button>Save</button>
      </div>
    </div>
  </form>
</div>
